<template>
  <div class="container-serialNumberSucesso">
    <b id="MODAL_SUCESSO">
      <div class="container-sucesso">
        <div class="container-titulo">
          <img
            v-if="svgIcon"
            :src="svgIcon"
            :alt="`icone ${device.deviceTypeName}`"
          />
          <div class="serialNumber-registrado">
            <p class="label-sucesso">Número de série<br>registrado<br>com sucesso</p>
          </div>
        </div>
        <div class="container-sucesso" v-if="myCiclicButton">
          <b-button :href="myCiclicButton" variant="success" class="myciclic-button rounded-pill">
            VOLTAR
          </b-button>
        </div>
      </div>
    </b>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'modalSucesso',
    data: () => ({
      myCiclicButton: ''
    }),
    created () {
      this.myCiclicButton = this.$route.query['my-ciclic-button']

      window.dataLayer.push({
        event: 'dispositivos-ciclic',
        categoria: 'cadastro-dispositivo',
        acao: 'numero-serie',
        rotulo: 'sucesso'
      })
    },
    computed: {
      ...mapState(['device']),
      svgIcon () {
        return this.device.deviceTypeName
          ? require(`@/assets/svg/icon-${this.device.deviceTypeName}-green-success.svg`)
          : null
      }
    }
  }
</script>

<style lang="scss" scoped>
  #MODAL_SUCESSO {
    .container-serialNumberSucesso{
      height: 100%;
      color: #324b68;
      border-radius: 12px;
      display: flex;
      align-items: center;
      padding-bottom: 1.5rem;
    }

    .container-titulo {
      display: flex;
      align-items: center;
    }

    .serialNumber-registrado {
      .label-sucesso {
        font-family: Oscine;
        font-size: 32px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        margin-bottom: 0;
      }
    }

    .container-sucesso {
      @media screen and (max-width: 450px) {
        padding: 10px;
      }
    }

    .myciclic-button {
      margin-top: 10px;
      padding: 10px 10%;
      width: 100%;
    }
  }
</style>
